(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Teslaaccount"] = factory();
	else
		root["Teslaaccount"] = root["Teslaaccount"] || {}, root["Teslaaccount"]["index"] = factory();
})(self, () => {
return 